module.exports = __webpack_public_path__ + "img/Tessellate19.e68d93d9.jpg";